import 'moment-timezone'
import React, { useEffect, useState } from 'react'
import { Image } from 'react-bootstrap'
import { connect, useDispatch, useSelector } from 'react-redux'

import { api_gateway } from '../../../conexoes/api'
import '../../../css/painelFaturas/fatDispositivos/fatAcoes.css'
import { mudarManejador, mudarOrdenador } from '../../../redux/actions/index'
import {
  elipseAmarelo,
  elipseAzul,
  elipseCinza,
  elipseVerde,
  elipseVermelho,
  setaDropdown
} from '../../../utils/alternanciaIcones'
import decryptJWT from '../../../utils/decryptJWT'
import { formatarData } from '../../../utils/formatadorDataTabela'
import { formatarMilhar } from '../../../utils/formatarMilhar'

import TabelaSimcardFaturas from './tabelaFaturas'

function CarregarColunas(props) {
  let colunaFaturas
  const [colunas, setColunas] = useState([])
  const [render, setRender] = useState(false)
  const [colunasMongo, setColunasMongo] = useState()
  const [colunasMongoSimcards, setColunasMongoSimcards] = useState()

  const despacho = useDispatch()
  let ordenador = useSelector((state) => state.manejadorState.ordenador)

  function handlerDesativarImagens(imagem, terminacao) {
    const elementosAtivosDESC = document.querySelectorAll(
      '.icone-ordenacao-DESC'
    )
    const elementosAtivosASC = document.querySelectorAll('.icone-ordenacao-ASC')
    elementosAtivosDESC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosASC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosDESC.forEach((el) =>
      el.classList.remove('icone-ordenacao-DESC')
    )
    elementosAtivosASC.forEach((el) =>
      el.classList.remove('icone-ordenacao-ASC')
    )

    imagem.classList.remove('d-none')
    imagem.classList.add('icone-ordenacao-' + terminacao)
  }

  function handleRemoverImagens(imagem) {
    const elementosAtivosDESC = document.querySelectorAll(
      '.icone-ordenacao-DESC'
    )
    const elementosAtivosASC = document.querySelectorAll('.icone-ordenacao-ASC')
    elementosAtivosDESC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosASC.forEach((el) => el.classList.add('d-none'))
    elementosAtivosDESC.forEach((el) =>
      el.classList.remove('icone-ordenacao-DESC')
    )
    elementosAtivosDESC.forEach((el) =>
      el.classList.remove('icone-ordenacao-ASC')
    )
    elementosAtivosASC.forEach((el) =>
      el.classList.remove('icone-ordenacao-ASC')
    )
    elementosAtivosASC.forEach((el) =>
      el.classList.remove('icone-ordenacao-DESC')
    )
    imagem.classList.remove('icone-ordenacao-ASC')
    imagem.classList.remove('icone-ordenacao-DESC')
  }

  async function handlerOrdenador(nomeOrdenador, nomeDiferenciado) {
    let isItDescrescente = false
    const imagem = document.getElementById(nomeOrdenador + nomeDiferenciado)
    //verifica esta mudando a forma de ordenacao no mesmo elemento
    if (
      nomeOrdenador === ordenador.split(' ASC')[0] ||
      nomeOrdenador === ordenador.split(' DESC')[0]
    ) {
      await ordenador.split(' ').map((item_ordenador) => {
        //verifica se existe tal item e muda para decrescente
        if (item_ordenador === 'ASC') {
          //Sera tal ordenador para decrescente
          ordenador = nomeOrdenador + ' DESC'
          isItDescrescente = true
          //transforma a imagem para o modo DESC ao qual mosta a imagem normalmente e faz a limpeza dos outros icones
          handlerDesativarImagens(imagem, 'ASC')
        }
        if (item_ordenador === 'DESC') {
          //Sera tal ordenador para crescente
          ordenador = ''
          isItDescrescente = false
          //transforma a imagem para o modo ASC ao qual mosta a imagem rotacionada 180deg e faz a limpeza dos outros icones
          handleRemoverImagens(imagem)
        }
      })
    } else if (!isItDescrescente) {
      ordenador = nomeOrdenador + ' ASC'
      //Adiciona a classe de crescente para a imagem e faz a limpeza dos outros icones
      handlerDesativarImagens(imagem, 'DESC')
    }
    despacho(mudarOrdenador(JSON.parse(JSON.stringify(ordenador))))
  }

  const onDragEnd = async (fromIndex, toIndex) => {
    //nao deixa colocar nas primeiras duas colunas que sao o select e o descricao de linha
    if (toIndex >= 0) {
      let columnsCopy = []
      let clunasHidden = []
      //retirado dois pois os dois primeiras colunas sao da linha expandida e do select
      //src  https://codesandbox.io/s/qz20y44449?file=/index.js:1290-1525
      //ORDEM NO ARRAY
      await Promise.all(
        colunas.map((item_colunas) => {
          if (!item_colunas.hidden && item_colunas.hidden != true) {
            columnsCopy.push(item_colunas)
          } else {
            clunasHidden.push(item_colunas)
          }
        })
      )
      //DADOS NO MONGO DA ORDEM
      let itemColunaFrom = JSON.parse(JSON.stringify(columnsCopy[fromIndex]))
      let itemColunaTo = JSON.parse(JSON.stringify(columnsCopy[toIndex]))

      //ORDEM NO ARRAY
      const item = columnsCopy.splice(fromIndex, 1)[0]
      columnsCopy.splice(toIndex, 0, item)

      //ORDEM NO ARRAY
      await Promise.all(
        clunasHidden.map((item_clunasHidden) => {
          columnsCopy.push(item_clunasHidden)
        })
      )

      //ordena as colunas no mongo para poder fazer a alteracao de ordem
      // colunasMongo.sort(function (a, b) { return a.ordem - b.ordem });
      //se for movido da direita pra esquesda
      //adiciona 1 nos elementos que estiverem entre o elemento movido e onde ele foi movido
      if (itemColunaFrom.ordem > itemColunaTo.ordem) {
        await Promise.all(
          colunasMongo.map((item_colunasMongo) => {
            if (
              itemColunaFrom.ordem > item_colunasMongo.ordem &&
              itemColunaTo.ordem <= item_colunasMongo.ordem
            ) {
              item_colunasMongo.ordem += 1
            }
            if (itemColunaFrom.dataField === item_colunasMongo.id) {
              item_colunasMongo.ordem = itemColunaTo.ordem
            }
          })
        )
      }
      //se for movido da esquerda pra direita
      //adiciona 1 nos elementos que estiverem entre o elemento movido e onde ele foi movido so que ao contrario
      if (itemColunaFrom.ordem < itemColunaTo.ordem) {
        await Promise.all(
          colunasMongo.map((item_colunasMongo) => {
            if (
              itemColunaTo.ordem >= item_colunasMongo.ordem &&
              itemColunaFrom.ordem < item_colunasMongo.ordem
            ) {
              item_colunasMongo.ordem -= 1
            }
            if (itemColunaFrom.dataField === item_colunasMongo.id) {
              item_colunasMongo.ordem = itemColunaTo.ordem
            }
          })
        )
      }

      //ATUALIZA A ORDEM DAS COLUNAS
      await Promise.all(
        columnsCopy.map((item_columnsCopy) => {
          colunasMongo.map((item_colunasMongo) => {
            if (item_columnsCopy.dataField === item_colunasMongo.id) {
              item_columnsCopy.ordem = item_colunasMongo.ordem
            }
          })
        })
      )

      //salva as alteracoes

      await api_gateway.post('/m1/servicos/dados/alterar_colunas_simcard', {
        email: decryptJWT('email'),
        colunas: colunasMongoSimcards,
        colunasFaturas: colunasMongo
      })

      setColunas(columnsCopy)
    }
  }

  useEffect(() => {
    setColunas([])
    async function checarFiltros() {
      despacho(mudarManejador('fatDispositivos'))

      await api_gateway
        .get(
          '/m1/servicos/token/buscar_colunas_faturas?email=' +
            encodeURIComponent(decryptJWT('email'))
        )
        .then(async function (resposta) {
          colunaFaturas = resposta.data.dados.colunasFaturas
          setColunasMongo(colunaFaturas)

          let colunasSimcards = resposta.data.dados.colunas
          setColunasMongoSimcards(colunasSimcards)

          /* ATENÇÃO! Não apagar as COLUNAS comentadas. 
                        Pois se mudarem de ideia, outro dev pode demorar dias para restaurá-las.
                    */
          const colunasTemporario = [
            {
              dataField: 'DS_CONTA',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() => handlerOrdenador('DS_CONTA', 'DS_CONTA')}
                >
                  Conta
                  <Image
                    id="DS_CONTADS_CONTA"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('DS_CONTA'),
              formatter: (cell, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {cell}
                  </p>
                )
              }
            },
            {
              dataField: 'DS_OPERADORA',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() =>
                    handlerOrdenador('DS_OPERADORA', 'DS_OPERADORA')
                  }
                >
                  Operadora
                  <Image
                    id="DS_OPERADORADS_OPERADORA"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('DS_OPERADORA'),
              formatter: (cell, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {cell}
                  </p>
                )
              }
            },
            {
              dataField: 'DS_FORNECEDOR',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() =>
                    handlerOrdenador('DS_FORNECEDOR', 'DS_FORNECEDOR')
                  }
                >
                  Fornecedor
                  <Image
                    id="DS_FORNECEDORDS_FORNECEDOR"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('DS_FORNECEDOR'),
              formatter: (cell, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {cell}
                  </p>
                )
              }
            },
            {
              dataField: 'CALLERID',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() => handlerOrdenador('CALLERID', 'CALLERID')}
                >
                  Linha
                  <Image
                    id="CALLERIDCALLERID"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('CALLERID'),
              formatter: (cell, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {cell}
                  </p>
                )
              }
            },
            {
              dataField: 'ICCID',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() => handlerOrdenador('ICCID', 'ICCID')}
                >
                  ICCID
                  <Image
                    id="ICCIDICCID"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('ICCID'),
              formatter: (cell, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {cell}
                  </p>
                )
              }
            },
            {
              dataField: 'DS_CICLO_VIDA',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() =>
                    handlerOrdenador('DS_CICLO_VIDA', 'DS_CICLO_VIDA')
                  }
                >
                  Ciclo de vida
                  <Image
                    id="DS_CICLO_VIDADS_CICLO_VIDA"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('DS_CICLO_VIDA'),
              formatter: (cell, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {cell}
                  </p>
                )
              }
            },
            {
              dataField: 'DS_PLANO',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() => handlerOrdenador('DS_PLANO', 'DS_PLANO')}
                >
                  Nome do plano
                  <Image
                    id="DS_PLANODS_PLANO"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('DS_PLANO'),
              formatter: (cell, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {cell}
                  </p>
                )
              }
            },
            {
              dataField: 'FAT_N2_VALOR_PLANO',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() =>
                    handlerOrdenador('FAT_N2_VALOR_PLANO', 'FAT_N2_VALOR_PLANO')
                  }
                >
                  Valor
                  <Image
                    id="FAT_N2_VALOR_PLANOFAT_N2_VALOR_PLANO"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('FAT_N2_VALOR_PLANO'),
              formatter: (cell) => {
                const valor = parseFloat(cell)
                return (
                  <p className="fonte-cor-1 label-tabela-1">
                    R${' '}
                    {!valor || isNaN(valor)
                      ? '0.00'
                      : formatarMilhar(valor)}{' '}
                  </p>
                )
              }
            },
            {
              dataField: 'DATA_ATIVACAO',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() =>
                    handlerOrdenador('DATA_ATIVACAO', 'DATA_ATIVACAO')
                  }
                >
                  Ativação
                  <Image
                    id="DATA_ATIVACAODATA_ATIVACAO"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('DATA_ATIVACAO'),
              formatter: (cell) => {
                return formatarData(cell, true)
              }
            },
            {
              dataField: 'DS_PEDIDO_OPERADORA',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() =>
                    handlerOrdenador(
                      'DS_PEDIDO_OPERADORA',
                      'DS_PEDIDO_OPERADORA'
                    )
                  }
                >
                  Pedido
                  <Image
                    id="DS_PEDIDO_OPERADORADS_PEDIDO_OPERADORA"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('DS_PEDIDO_OPERADORA'),
              formatter: (cell, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {cell}
                  </p>
                )
              }
            },
            {
              dataField: 'DS_NOTA_FISCAL',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() =>
                    handlerOrdenador('DS_NOTA_FISCAL', 'DS_NOTA_FISCAL')
                  }
                >
                  Nota fiscal
                  <Image
                    id="DS_NOTA_FISCALDS_NOTA_FISCAL"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('DS_NOTA_FISCAL'),
              formatter: (cell, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {cell}
                  </p>
                )
              }
            },
            {
              dataField: 'DATA_PRAZO',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() => handlerOrdenador('DATA_PRAZO', 'DATA_PRAZO')}
                >
                  Prazo do contrato
                  <Image
                    id="DATA_PRAZODATA_PRAZO"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('DATA_PRAZO'),
              formatter: (cell) => {
                return formatarData(cell, true)
              }
            },
            {
              dataField: 'DATA_COMPRA',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() => handlerOrdenador('DATA_COMPRA', 'DATA_COMPRA')}
                >
                  Data da compra
                  <Image
                    id="DATA_COMPRADATA_COMPRA"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('DATA_COMPRA'),
              formatter: (cell) => {
                return formatarData(cell, true)
              }
            },
            {
              dataField: 'DATA_DESBLOQUEIO',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() =>
                    handlerOrdenador('DATA_DESBLOQUEIO', 'DATA_DESBLOQUEIO')
                  }
                >
                  Data do desbloqueio
                  <Image
                    id="DATA_DESBLOQUEIODATA_DESBLOQUEIO"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('DATA_DESBLOQUEIO'),
              formatter: (cell) => {
                return formatarData(cell, true)
              }
            },
            {
              dataField: 'DS_STATUS_SOLIC',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() =>
                    handlerOrdenador('DS_STATUS_SOLIC', 'DS_STATUS_SOLIC')
                  }
                >
                  Status solicitação
                  <Image
                    id="DS_STATUS_SOLICDS_STATUS_SOLIC"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('DS_STATUS_SOLIC'),
              formatter: (cell, row) => {
                let img
                switch (cell) {
                  case 'Aberta':
                    img = elipseAzul()
                    break
                  case 'Concluída':
                    img = elipseVerde()
                    break
                  case 'Cancelada':
                    img = elipseVermelho()
                    break
                  case 'Em Andamento':
                    img = elipseAmarelo()
                    break
                  default:
                    img = elipseCinza()
                }
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    <Image className="img-eclipse-status" src={img} />
                    {cell}
                  </p>
                )
              }
            },
            {
              dataField: 'IA_NOME',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() => handlerOrdenador('IA_NOME', 'IA_NOME')}
                >
                  Nome
                  <Image
                    id="IA_NOMEIA_NOME"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('IA_NOME'),
              formatter: (cell, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {cell ? cell : '-'}
                  </p>
                )
              }
            },
            {
              dataField: 'IA_ENDERECO',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() => handlerOrdenador('IA_ENDERECO', 'IA_ENDERECO')}
                >
                  Endereço
                  <Image
                    id="IA_ENDERECOIA_ENDERECO"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('IA_ENDERECO'),
              formatter: (cell, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {cell ? cell : '-'}
                  </p>
                )
              }
            },
            {
              dataField: 'IA_CIDADE',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() => handlerOrdenador('IA_CIDADE', 'IA_CIDADE')}
                >
                  Cidade
                  <Image
                    id="IA_CIDADEIA_CIDADE"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('IA_CIDADE'),
              formatter: (cell, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {cell ? cell : '-'}
                  </p>
                )
              }
            },
            {
              dataField: 'IA_UF',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() => handlerOrdenador('IA_UF', 'IA_UF')}
                >
                  Estado
                  <Image
                    id="IA_UFIA_UF"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('IA_UF'),
              formatter: (cell, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {cell ? cell : '-'}
                  </p>
                )
              }
            },
            {
              dataField: 'IA_CEP',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() => handlerOrdenador('IA_CEP', 'IA_CEP')}
                >
                  CEP
                  <Image
                    id="IA_CEPIA_CEP"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('IA_CEP'),
              formatter: (cell, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {cell ? cell : '-'}
                  </p>
                )
              }
            },
            {
              dataField: 'IA_OBSERVACOES',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() =>
                    handlerOrdenador('IA_OBSERVACOES', 'IA_OBSERVACOES')
                  }
                >
                  Informações adicionais
                  <Image
                    id="IA_OBSERVACOESIA_OBSERVACOES"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('IA_OBSERVACOES'),
              formatter: (cell, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {cell ? cell : '-'}
                  </p>
                )
              }
            },
            {
              dataField: 'IA_MODELO_DISPOSITIVO',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() =>
                    handlerOrdenador(
                      'IA_MODELO_DISPOSITIVO',
                      'IA_MODELO_DISPOSITIVO'
                    )
                  }
                >
                  Modelo
                  <Image
                    id="IA_MODELO_DISPOSITIVOIA_MODELO_DISPOSITIVO"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('IA_MODELO_DISPOSITIVO'),
              formatter: (cell, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {cell ? cell : '-'}
                  </p>
                )
              }
            },
            {
              dataField: 'IA_MARCA_DISPOSITIVO',
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() =>
                    handlerOrdenador(
                      'IA_MARCA_DISPOSITIVO',
                      'IA_MARCA_DISPOSITIVO'
                    )
                  }
                >
                  Marca
                  <Image
                    id="IA_MARCA_DISPOSITIVOIA_MARCA_DISPOSITIVO"
                    className="d-none"
                    src={setaDropdown()}
                  />
                </button>
              ),
              hidden: !verificarColuna('IA_MARCA_DISPOSITIVO'),
              formatter: (cell, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {cell ? cell : '-'}
                  </p>
                )
              }
            },
            {
              dataField: 'SMS', //SMS_ATIVADO
              headerClasses: 'nao-selecionavel',
              text: (
                <button
                  className="btn-header-nome fonte-cor-1"
                  onClick={() => handlerOrdenador('SMS', 'SMS')}
                >
                  Envio de SMS
                  <Image id="SMSSMS" className="d-none" src={setaDropdown()} />
                </button>
              ),
              hidden: !verificarColuna('SMS'),
              formatter: (smsAtivado, row) => {
                return (
                  <p
                    className="fonte-cor-1 label-tabela-1"
                    key={row.CD_SIMCARD}
                  >
                    {smsAtivado ? 'Ativo' : 'Bloqueado'}
                  </p>
                )
              }
            }
          ]

          let ordenacaoColunas = []

          await Promise.all(
            colunasTemporario.map((item_colunasTemporario) => {
              colunaFaturas.map((item_colunaFaturas) => {
                if (item_colunaFaturas.id == item_colunasTemporario.dataField) {
                  item_colunasTemporario['ordem'] = item_colunaFaturas.ordem
                  ordenacaoColunas.push(item_colunasTemporario)
                }
              })
            })
          )
          //ordena os elementos
          ordenacaoColunas.sort(function (a, b) {
            return a.ordem - b.ordem
          })
          //seta as colunas
          setColunas(ordenacaoColunas)
          return resposta.data.dados
        })
    }

    checarFiltros()
  }, [render])

  function verificarColuna(id) {
    let valor = false
    colunaFaturas.map((item) => {
      if (item.id == id) {
        valor = item.valor
      }
    })
    return valor
  }

  return (
    <>
      {colunas.length !== 0 && (
        <TabelaSimcardFaturas
          onDragEnd={onDragEnd}
          colunas={colunas}
          render={render}
          setRender={setRender}
          conteudoBusca={props.conteudoBusca}
          filtros={props.filtros}
          buscaArquivo={props.buscaArquivo}
          ordenador={props.ordenador}
        />
      )}
    </>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros,
    buscaArquivo: state.buscaArquivoState.buscaArquivo,
    ordenador: state.manejadorState.ordenador
  }
}

export default connect(mapStateToProps)(React.memo(CarregarColunas))
